export default __webpack_public_path__ + "static/media/newlogo.882ddf22.svg";